exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/node_modules/core-js/modules/_wks-ext.js
// module id = qrqn
// module chunks = 0